import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaFacebookF, FaTiktok, FaGlobe, FaHeart } from "react-icons/fa";
import platformFacebook from "../assests/platformFacebook.jpg";
import platformTiktok from "../assests/platformTiktok.jpg";
import platformJvLands from "../assests/platformJvLandsApp.jpg";
import platformRishta from "../assests/platformRishtaApp.jpg";

const platforms = [
  {
    name: "Facebook",
    label: "JV Lands Marketing",
    href: "https://www.facebook.com/share/1DFCCgEBvf/?mibextid=wwXIfr",
    image: platformFacebook,
    crop: "facebook",
    Icon: FaFacebookF,
  },
  {
    name: "TikTok",
    label: "@jvlandsmarketing",
    href: "https://www.tiktok.com/@jvlandsmarketing?_r=1&_t=ZS-9A3FETDiNng",
    image: platformTiktok,
    crop: "tiktok",
    Icon: FaTiktok,
  },
  {
    name: "JV Lands",
    label: "Website & App",
    href: "https://jvlands.com",
    image: platformJvLands,
    crop: "jv",
    Icon: FaGlobe,
  },
  {
    name: "Rishta App",
    label: "Rishta Free",
    href: "https://rishtafree.online/",
    image: platformRishta,
    crop: "rishta",
    Icon: FaHeart,
  },
];

export default function FreePlatforms() {
  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease",
      delay: 40,
    });
  }, []);

  return (
    <section className="freePlatforms" id="free_platforms">
      <div className="freePlatformsInner">
        <div className="freePlatformsHead" data-aos="fade-up">
          <p className="freePlatformsEyebrow">Stay Connected</p>
          <h1 className="servicesHeadingText">Our Free Platforms</h1>
          <span className="freePlatformsRule" />
          <p className="servicesParaText freePlatformsIntro">
            Property updates, listings, and community support — all free to use.
          </p>
        </div>

        <div className="freePlatformsRow">
          {platforms.map((platform, index) => {
            const Icon = platform.Icon;
            return (
              <a
                key={platform.name}
                href={platform.href}
                target="_blank"
                rel="noopener noreferrer"
                className={`freePlatformCard freePlatformCard--${platform.crop}`}
                data-aos="fade-up"
                data-aos-delay={index * 80}
              >
                <div className="freePlatformMedia">
                  <img
                    src={platform.image}
                    alt={platform.name}
                    className={`freePlatformImg freePlatformImg--${platform.crop}`}
                  />
                </div>
                <div className="freePlatformMeta">
                  <span className="freePlatformBadge">
                    <Icon />
                  </span>
                  <div>
                    <h3>{platform.name}</h3>
                    <p>{platform.label}</p>
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
